/**
 *
 * ChallengeModeCpnt
 *
 */

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

import Swal from 'sweetalert2';
import VueScrollTo from 'vue-scrollto';

import TrackerButton from '@/components/TrackerButton.vue';

import { OpenStudentworkModalMixin } from '@/mixins/Studentwork/OpenStudentworkModal';

export default {
  name: 'ChallengeModeCpnt',

  mixins: [OpenStudentworkModalMixin],

  components: {
    TrackerButton,
  },

  data: () => {
    return {
      hideCurrentBtn: false,
    };
  },

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
    }),

    ...mapGetters({
      Course: 'MainModeCourse/Course',
      Books: 'MainModeCourse/Books',
      UnissuedBooks: 'MainModeCourse/UnissuedBooks',
      EarlyBooks: 'MainModeCourse/EarlyBooks',
      hasCurrentBook: 'MainModeCourse/hasCurrentBook',
    }),

    c_courseId() {
      return this.$route.params.courseId;
    },

    c_isHaveCurrentBook() {
      return this.hasCurrentBook && this.hasCurrentBook.isCurrent;
    },
  },

  methods: {
    ...mapActions({
      getCourseWithoutSetRequestStatus: 'MainModeCourse/getCourseWithoutSetRequestStatus',
    }),

    ...mapActions('MainModeCourse', {
      ma_getCourseMyTaskStatus: 'getCourseMyTaskStatus',
    }),

    ...mapMutations({
      mm_SET_GOTO_LAST_STUDY: 'SET_GOTO_LAST_STUDY',
    }),

    ///
    noAccessInfo(objBookReading) {
      if (!objBookReading.canAccess) {
        Swal.fire({
          width: '400px',
          backdrop: false,
          icon: 'warning',
          title: `没有权限`,
          text: '亲爱的学员您还没有购买该课程, 购买课程后再来吧～',
          showConfirmButton: false,
          timer: 1500,
        });
      } else if (objBookReading.c_isLockedByStudentWorkStatus) {
        Swal.fire({
          width: '400px',
          backdrop: false,
          icon: 'warning',
          title: `温馨提示`,
          text: '亲爱的学员，请先完成全部前置章节的作业提交以解锁当前章节～',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    go2History(bookId) {
      VueScrollTo.scrollTo(`#book-${bookId}`, 500, {
        container: '.webapp-layout-main',
        duration: 500,
        easing: 'linear',
        offset: -220,
      });
      setTimeout(() => {
        this.mm_SET_GOTO_LAST_STUDY(true);
        this.$router.push(`/course/${this.c_courseId}/book/${bookId}`);
      }, 500);
    },

    getCourseMyTaskStatus() {
      this.ma_getCourseMyTaskStatus({
        courseId: this.c_courseId,
      });
    },

    setHideCurrentBtn() {
      setTimeout(() => {
        this.hideCurrentBtn = true;
      }, 15000);
    },

    _challengeModeCpntCreated() {
      if (this.c_courseId === `${this.Course.courseId}`) {
        this.getCourseWithoutSetRequestStatus(this.c_courseId);
      }
      this.getCourseMyTaskStatus();
    },

    _challengeModeCpntMounted() {
      this.setHideCurrentBtn();
    },
  },

  created() {
    this._challengeModeCpntCreated();
  },

  mounted() {
    this._challengeModeCpntMounted();
  },
};
